<template>
  <div class="h-100">
    <div class="content-page pr-3 pl-3 pt-2 pb-2 h-100">
      <div class="row h-100 sm-gutters">
        <div class="col-4">
          <div class="h-100 bg-white">
            <div class="panel-primary">
              <div class="panel-body p-0">
                <div>
                  <div
                    class="tab-pane active table-responsive color-table"
                    id="event"
                  >
                    <table class="table table-hover">
                      <thead>
                        <tr class="table-color">
                          <th>{{ t.t(dictEnum.LBL_UserGrp) }}</th>
                          <th>{{ t.t(dictEnum.LBL_Description) }}</th>
                          <th></th>
                        </tr>
                      </thead>

                      <tr
                        v-for="(data, dataIndex) in tableData"
                        :key="dataIndex"
                        :class="{
                          HRDEPTClass: HRDEPT(data)
                        }"
                      >
                        <td>{{ data.UserGrp }}</td>
                        <td>{{ data.GrpDesc }}</td>
                        <td>
                          <div class="float-right">
                            <font-awesome-icon
                              icon="edit"
                              style="cursor:pointer"
                              color="#337ab7"
                              @click="editUserGrpRight(data.UserGrp)"
                            />
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <div
            class="h-100 bg-white font-weight-bold"
            style="height: calc(100vh - 120px) !important; overflow: auto; "
          >
            <div class="tab-pane active table-responsive color-table h-90">
              <div class="row table2_header" style="margin: 0;">
                <div class="col-sm-5 pt-0 pb-0 pr-0 pl-0 ">
                  {{ this.t.t(dictEnum.LBL_Permissions) }}
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr class="table-color">
                      <th>
                        {{ t.t(dictEnum.MENU_UserGrpRights) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Write)">
                        {{ t.t(dictEnum.LBL_Create) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Delete)">
                        {{ t.t(dictEnum.BTN_Delete) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Change)">
                        {{ t.t(dictEnum.LBL_Edit) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Import)">
                        {{ t.t(dictEnum.LBL_Import) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Export)">
                        {{ t.t(dictEnum.BTN_Export) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Print)">
                        {{ t.t(dictEnum.LBL_Print) }}
                      </th>
                      <th @click="selectAllRights(Settings.Permission.Read)">
                        {{ t.t(dictEnum.LBL_View) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(option, i) in editpagedata"
                      v-bind:key="option.MenuID"
                      v-show="option.show"
                    >
                      <td @click="selectRowRight(option.MenuID)">
                        {{ option.EDesc }}
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwWrite"
                          :v-id="editpagedata[i].AlwWrite"
                          :value="editpagedata[i].AlwWrite"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwDel"
                          :value="editpagedata[i].AlwDel"
                          :v-id="editpagedata[i].AlwDel"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwChg"
                          :value="editpagedata[i].AlwChg"
                          :v-id="editpagedata[i].AlwChg"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwImp"
                          :value="editpagedata[i].AlwImp"
                          :v-id="editpagedata[i].AlwImp"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwExp"
                          :value="editpagedata[i].AlwExp"
                          :v-id="editpagedata[i].AlwExp"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwPrt"
                          :value="editpagedata[i].AlwPrt"
                          :v-id="editpagedata[i].AlwPrt"
                        />
                      </td>
                      <td>
                        <input
                          type="checkbox"
                          v-model="editpagedata[i].AlwRead"
                          :value="editpagedata[i].AlwRead"
                          :v-id="editpagedata[i].AlwRead"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="h-10">
              <b-col sm="12" class="text-right">
                <button
                  v-if="hasRight('AlwChg')"
                  type="button"
                  class="btn btn-danger"
                  @click="save"
                >
                  {{ this.t.t(dictEnum.BTN_Save) }}
                </button>
              </b-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import moment from "moment";
import MenuRightSerivce from "@/service/MenuRightService";
import UserGroupService from "@/service/UserGroupService";
import UserGroupRightService from "@/service/UserGroupRightService";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import SweetAlertService from "@/service/SweetAlertService";
import StoreGetter from "@/constants/StoreGetter";
import Settings from "../../constants/Settings";

export default {
  components: {
    DatePicker,
    moment
  },
  computed: {
    t() {
      return t;
    },
    user() {
      return this.$store.getters[StoreGetter.user];
    }
  },
  data() {
    return {
      menuRights: { allRights: {}, rightsForThisMenu: {} },
      menuId: Settings.MenuID.UserGroupsRights,
      Settings: Settings,
      dictEnum: dictEnum,
      columns: ["UserGrp", "GrpDesc", "Action"],
      tableData: [],
      options: {
        filterable: false,
        perPageValues: [],
        sortable: [],
        skin: "table table-hover v-midle",
        headings: {
          UserGrp: "User Group",
          GrpDesc: "Group Description",
          Action: "Action"
        },
        columnsClasses: {}
      },
      editpagedata: []
    };
  },

  methods: {
    hasRight(key, menuId) {
      if (Object.keys(this.menuRights.allRights).length === 0) {
        return false;
      } else {
        return MenuRightSerivce.hasRightInMenu(
          this.menuRights.allRights,
          menuId ? menuId : this.menuId,
          key
        );
      }
    },
    assignRights() {
      this.menuRights.allRights = this.$store.getters[StoreGetter.sysMenu];

      this.menuRights.rightsForThisMenu = this.menuRights.allRights.find(
        x => x.MenuID == this.menuId
      );
    },
    async addOrUpdateEvent() {
      if (!this.event.EventCode) {
        this.addOrUpdateEventApiCall();
      } else {
        const sweetAlertOptions = {
          title: this.t.t(dictEnum.WARN_Confirm),
          text: this.t.t(dictEnum.WARN_UpdateEvent),
          cancelButtonText: this.t.t(dictEnum.BTN_Cancel),
          confirmButtonText: this.t.t(dictEnum.BTN_Confirm)
        };
        const result = await SweetAlertService.question(sweetAlertOptions);
        if (result.value) {
          await this.addOrUpdateEventApiCall();
        }
      }
    },
    async editUserGrpRight(UserGrp) {
      const obj = {
        userGrp: UserGrp
      };

      const response = await UserGroupRightService.getUserGroupRight(obj);
      if (response.data.IsSuccess) {
        const sysParams = this.$store.getters[StoreGetter.sysParams];
        let modClk = true,
          modLv = true,
          modRecu = true,
          modPay = true;
        const clkFind = sysParams.find(
          x => x.ParamCode == Settings.SysParams.ModCLK
        );
        if (clkFind) {
          modClk = clkFind.ParamVal.toLowerCase() === "true";
        }
        const lvFind = sysParams.find(
          x => x.ParamCode == Settings.SysParams.ModLv
        );
        if (lvFind) {
          modLv = lvFind.ParamVal.toLowerCase() === "true";
        }
        const RecuFind = sysParams.find(
          x => x.ParamCode == Settings.SysParams.ModRecu
        );
        if (RecuFind) {
          modRecu = RecuFind.ParamVal.toLowerCase() === "true";
        }
        const PayFind = sysParams.find(
          x => x.ParamCode == Settings.SysParams.ModPay
        );
        if (PayFind) {
          modPay = PayFind.ParamVal.toLowerCase() === "true";
        }

        response.data.Data.forEach(menu => {
          switch (menu.MenuID) {
            case Settings.MenuID.Approval:
              menu.show = modLv;
              break;
            case Settings.MenuID.OutdoorWork:
              menu.show = modClk;
              break;
            case Settings.MenuID.Candidates:
              menu.show = modRecu;
              break;
            case Settings.MenuID.LeaveApplication:
              menu.show = modLv;
              break;
            case Settings.MenuID.Report:
              menu.show = modClk || modLv;
              break;
            case Settings.MenuID.StaffLeaveRecord:
              menu.show = modLv;
              break;
            case Settings.MenuID.StaffAttendance:
              menu.show = modClk;
              break;
            case Settings.MenuID.MonthlyLeaveBalance:
              menu.show = modLv;
              break;
            case Settings.MenuID.OutdoorWorkAllowance:
              menu.show = modClk;
              break;
            case Settings.MenuID.TaxReturn:
              menu.show = modClk;
              break;
            case Settings.MenuID.MM_LeaveType:
              menu.show = modLv;
              break;
            case Settings.MenuID.MM_StaffGrading:
              menu.show = modLv || modRecu;
              break;
            case Settings.MenuID.MM_AnnualLeavePlan:
              menu.show = modLv;
              break;
            case Settings.MenuID.MM_WorkType:
              menu.show = modLv;
              break;
            case Settings.MenuID.MM_Holiday:
              menu.show = modClk || modLv;
              break;
            case Settings.MenuID.MM_ShiftType:
              menu.show = modClk;
              break;
            case Settings.MenuID.MM_Roster:
              menu.show = modClk;
              break;
            case Settings.MenuID.MM_Loc:
              menu.show = modClk;
              break;
            case Settings.MenuID.S_Academic:
              menu.show = modLv || modRecu || modPay;
              break;
            case Settings.MenuID.S_Skill:
              menu.show = modLv || modRecu || modPay;
              break;
            case Settings.MenuID.S_SourceofAppli:
              menu.show = modLv || modRecu || modPay;
              break;
            case Settings.MenuID.S_BenefitPlan:
              menu.show = modLv || modRecu || modPay;
              break;
            case Settings.MenuID.S_DocumentTemplate:
              menu.show = modLv || modRecu || modPay;
              break;
            case Settings.MenuID.S_Assess:
              menu.show = modRecu;
              break;
            case Settings.MenuID.S_PayProfile:
              menu.show = modPay;
              break;
            case Settings.MenuID.S_PayGroup:
              menu.show = modPay;
              break;
            case Settings.MenuID.S_PayType:
              menu.show = modPay;
              break;
            case Settings.MenuID.S_PayMethod:
              menu.show = modPay;
              break;
            case Settings.MenuID.S_IncType:
              menu.show = modPay;
              break;
            case Settings.MenuID.Candidate:
              menu.show = modRecu;
              break;
            case Settings.MenuID.Job:
              menu.show = modRecu;
              break;
            case Settings.MenuID.NewCandidate:
              menu.show = modRecu;
              break;
            case Settings.MenuID.JobApplicationForm:
              menu.show = modRecu;
              break;
            case Settings.MenuID.Enquiry:
              menu.show = modRecu;
              break;
            case Settings.MenuID.Payroll:
              menu.show = modPay;
              break;
            case Settings.MenuID.PayrollTrial:
              menu.show = modPay;
              break;
            case Settings.MenuID.SpecialPayment:
              menu.show = modPay;
              break;
            case Settings.MenuID.PayrollAdjustment:
              menu.show = modPay;
              break;
            case Settings.MenuID.PayrollApproval:
              menu.show = modPay;
              break;
            case Settings.MenuID.FinalPayment:
              menu.show = modPay;
              break;
            default:
              menu.show = true;
          }
        });

        this.editpagedata = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    async save() {
      const obj = { model: this.editpagedata };
      const response = await UserGroupRightService.updateUserGroupRight(obj);
      if (response.data.IsSuccess) {
        this.editpagedata = response.data.Data;
        SweetAlertService.success("Success", response.data.Message);
        const userRightAPIObj = {
          userId: this.$store.getters[StoreGetter.user].UserID
        };
        const responseUserRights = await UserGroupRightService.getMenuRightForUser(
          userRightAPIObj
        );
        if (responseUserRights.data.IsSuccess) {
          await this.$store.dispatch({
            type: "SysMenuStore/refreshSysMenu",
            payload: responseUserRights.data.Data
          });
        } else {
          SweetAlertService.warning("Warn", responseUserRights.data.Message);
        }
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    async getDataTable() {
      const obj = {};
      const response = await UserGroupService.getUserGroups(obj);
      if (response.data.IsSuccess) {
        this.tableData = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },

    HRDEPT(data) {
      // HR dept user groups
      const list = this.$store.state.SysParamsStore.sysParams;
      const find = list.find(x => x.ParamCode == Settings.SysParams.HRDept);
      if (find) {
        const HRDEPTArray = find.ParamVal.split(",");
        return HRDEPTArray.includes(data.UserGrp);
      }
    },

    selectAllRights(right) {
      const find = this.editpagedata.find(x => x[right] == true);
      if (find) {
        this.editpagedata.forEach(x => (x[right] = false));
      } else {
        this.editpagedata.forEach(x => (x[right] = true));
      }
    },

    selectRowRight(menuId) {
      const find = this.editpagedata.find(x => x.MenuID == menuId);
      if (
        find.AlwChg ||
        find.AlwDel ||
        find.AlwExp ||
        find.AlwImp ||
        find.AlwPrt ||
        find.AlwRead ||
        find.AlwWrite
      ) {
        find.AlwChg = false;
        find.AlwDel = false;
        find.AlwExp = false;
        find.AlwImp = false;
        find.AlwPrt = false;
        find.AlwRead = false;
        find.AlwWrite = false;
      } else {
        find.AlwChg = true;
        find.AlwDel = true;
        find.AlwExp = true;
        find.AlwImp = true;
        find.AlwPrt = true;
        find.AlwRead = true;
        find.AlwWrite = true;
      }
    }
  },

  mounted() {
    this.assignRights();
    this.getDataTable();

    this.options = {
      filterable: false,
      perPageValues: [],
      sortable: [],
      skin: "table table-hover v-midle",
      headings: {
        UserGrp: t.t(dictEnum.LBL_UserGrp),
        GrpDesc: t.t(dictEnum.LBL_Description),
        Action: t.t(dictEnum.BTN_Update)
      },
      texts: {
        noResults: t.t(dictEnum.LBL_NoData),
        count: `${t.t(dictEnum.LBL_Record)}({count})`
      },
      columnsClasses: {}
    };
  }
};
</script>

<style scoped>
.mx-datepicker {
  position: relative;
  display: inline-block;
  width: 122px;
  color: #73879c;
  font: 14px/1.5 "Helvetica Neue", Helvetica, Arial, "Microsoft Yahei",
    sans-serif;
}

.pick-panel-date {
  /* width: 200px !important;
  display: block;
  margin: 14px -55px !important; */
  padding: 0;
}

.pick-panel {
  width: 315px !important;
}

.radio input[type="radio"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
}

.checkbox input[type="checkbox"] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 18px;
  height: 18px;
  margin-top: inherit;
}
div#event table tr th + th + th {
  width: 100px;
}

.mx-input-append .mx-calendar-icon {
  background-image: url();
  background-position: 50%;
  background-repeat: no-repeat;
}
input#Overseals,
input#Local {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
  width: 20px !important;
  height: 24px !important;
}

.HRDEPTClass {
  background-color: #ebf6ff;
}

>>> .b-form-time-control button {
  padding: 0 !important;
}

>>> .bi-circle-fill {
  height: 0.5em;
  width: 0.5em;
}

>>> .selected-date {
  max-width: 100% !important;
}
>>> .VuePagination__pagination {
  margin: 0px;
}

>>> .VuePagination__count {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/S060000-Admin/S060300-UserGroupRights.vue